import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { loadStripe } from '@stripe/stripe-js';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subscription } from 'src/app/models/subscription.model';
import { getAuth } from '@angular/fire/auth';
// inside your PayComponent (replace startSubscription function)
import { SubscriptionService } from 'src/app/services/subscription.service';
import { filter, firstValueFrom } from 'rxjs';
import { User } from 'src/app/models/user.model';
const stripePromise = loadStripe(environment.stripePublicKey);

@Component({
  selector: 'app-pay',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.scss'],
  imports: [CommonModule, FormsModule],
})
export class PayComponent implements OnInit {
  stripe: any;
  elements: any;
  card: any = null;
  clientSecret: string | null = null;
  user!: User;
  subscription: Subscription | null = null;
  paymentType: 'one-time' | 'recurring' = 'one-time';
  paymentMethod: 'card' | 'us_bank_account' = 'us_bank_account';
  isSubscribed: boolean = false;
  feePercent: number = 0.04;
  feeAmount: number = 0;
  totalAmount: number = 0;
loadingPayment: boolean = false;
baseAmount: number =  500;
  // Bank linking state
  bankLinked: boolean = false;
  linkedClientSecret: string | null = null;

  constructor(
    private functions: Functions,
    private router: Router,
    private authService: AuthService,
    private subscriptionService: SubscriptionService,
    private route: ActivatedRoute
  ) {}


onPaymentMethodChange(method: 'us_bank_account' | 'card') {
  this.paymentMethod = method;
  this.feePercent = method === 'us_bank_account' ? 0.02 : 0.04;
  this.calculateTotals();
}

onAmountChange(amount: number) {
  this.baseAmount = amount;
  this.calculateTotals();
}

calculateTotals() {
  this.feeAmount = +(this.baseAmount * this.feePercent).toFixed(2);
  this.totalAmount = +(this.baseAmount + this.feeAmount).toFixed(2);
}

  async ngOnInit() {
    // Wait until auth is fully hydrated
    this.user = await firstValueFrom(
      this.authService.user$.pipe(filter(u => !!u))
    );
    this.route.queryParamMap.subscribe(params => {
      const type = params.get('type');
      if (type === 'recurring') {
        this.paymentType = 'recurring';
      }
    });
    this.calculateFeeAndTotal();
    await this.checkSubscriptionStatus(this.user.uid);
  }




  calculateFeeAndTotal() {
    this.feeAmount = +(this.baseAmount * this.feePercent).toFixed(2);
    this.totalAmount = +(this.baseAmount + this.feeAmount).toFixed(2);
  }

  async checkSubscriptionStatus(uid: string) {
    const checkStatus = httpsCallable(this.functions, 'checkSubscriptionStatus');
    const res: any = await checkStatus({ uid });
    this.isSubscribed = res.data?.isSubscribed;
    this.subscription = res.data?.subscription;

    if (this.isSubscribed && this.subscription) {
      this.displaySubscriptionDetails(this.subscription);
    }
  }
async handleSubmit(event: Event) {
    event.preventDefault();
    this.loadingPayment = true; // show full-page spinner

    try {
      const uid = this.user.uid;
      const amountInCents = Math.round(this.totalAmount * 100);

      if (this.paymentType === 'recurring') {
        await this.startSubscription(this.paymentMethod);
        return;
      }
     try {
    const createSession = httpsCallable(
      this.functions,
      'createOneTimeCheckoutSession'
    );

    const res: any = await createSession({
      uid: this.user.uid,
      baseAmount: Math.round(this.baseAmount * 100),
      paymentMethod: this.paymentMethod,
      successUrl: `${window.location.origin}/tenant/success`,
      cancelUrl: `${window.location.origin}/tenant/pay`,
    });

    window.location.href = res.data.url;
  } catch (err: any) {
    console.error(err);
    alert(err.message || 'Unable to start checkout');
    this.loadingPayment = false;
  }
    } catch (err: any) {
      console.error(err);
      alert(err.message || 'Payment failed. Please try again.');
    } finally {
      this.loadingPayment = false; // hide spinner
    }
  }

setPaymentType(type: 'one-time' | 'recurring') {
  this.paymentType = type;

  // Default ACH for subscriptions
  if (type === 'recurring') {
    this.paymentMethod = 'us_bank_account';
  }

  this.calculateTotals();
}

  async startSubscription(paymentMethod: string) {
    this.loadingPayment = true;
    const uid = this.user.uid;
    const monthlyCents = Math.round(this.totalAmount * 100);

    try {
      const successUrl = `${window.location.origin}/subscription-success`;
      const cancelUrl = `${window.location.origin}/subscription-cancel`;

      const url = await this.subscriptionService.createSubscriptionSession(
        uid,
        monthlyCents,
        'Test Address',
        paymentMethod,
        successUrl,
        cancelUrl
      );

      window.location.href = url; // redirect to Stripe
    } catch (err: any) {
      console.error('startSubscription error:', err);
      alert(err.message || 'Failed to start subscription');
      this.loadingPayment = false;
    }
  }

  async goToCustomerPortal() {
    const portal = httpsCallable(this.functions, 'createCustomerPortalSession');
    const res: any = await portal({ uid: this.user.uid });
    window.location.href = res.data.url;
  }

  displaySubscriptionDetails(sub: Subscription) {
    document.getElementById('subscription-status')!.innerText = `Status: ${sub.status}`;
    document.getElementById('amount-paid')!.innerText = `Price ID: ${sub.priceId}`;
    document.getElementById('days-until-due')!.innerText = sub.daysUntilDue
      ? `Days Until Due: ${sub.daysUntilDue}`
      : '';
  }

  async cancelSubscription() {
    const uid = this.user.uid;
    const cancelSub = httpsCallable(this.functions, 'cancelUserSubscription');
    await cancelSub({ uid: uid });
    alert('Subscription cancelled.');
    await this.checkSubscriptionStatus(uid);
  }
}


